import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { UpdatePermitRegister, UpdatePermitRegisterVariables } from "./__generated__/UpdatePermitRegister";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";

const UPDATE_PERMIT_REGISTER = gql`
  ${CORE_PERMIT_REGISTER_FIELDS}
  mutation UpdatePermitRegister($permitRegisterId: String!, $title: String!, $description: String, $permitTypeIds: [String!]) {
    updatePermitRegister(input: { permitRegisterId: $permitRegisterId, title: $title, description: $description, permitTypeIds: $permitTypeIds }) {
      register {
        ...CorePermitRegisterFields
      }
    }
  }
`;

export function useUpdatePermitRegister() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    UpdatePermitRegister,
    UpdatePermitRegisterVariables
  >(UPDATE_PERMIT_REGISTER, { errorPolicy: "all" });

  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
